import React from "react";
import Link from "components/link";
import { useSettings } from "hooks/useStore";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel, Autoplay } from "swiper/modules";
import { ReactComponent as StandardArrow } from "svgs/right-arrow.svg";
import clsx from "clsx/lite";

const DesktopSpecialLinks = ({ contactInfo, hideHeaderExtraLinks, embedHeader }) => {
	const { isSearchOpen, toggleSearch, isMenuOpen } = useSettings(["isSearchOpen", "toggleSearch", "isMenuOpen"]);

	const settings = {
		loop: true,
		modules: [Navigation, Mousewheel, Autoplay],
		slidesPerView: 1,
		speed: 1400,
		a11y: true,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
		},
		navigation: {
			enabled: true,
			nextEl: ".right-arrow-an",
			prevEl: ".left-arrow-an",
		},
	};

	return (
		<div className={clsx(
			"desktop-special-links",
			embedHeader && "embed-desktop-special-links",
			isMenuOpen ? "max-h-0 !p-0 lg:!py-1.5 lg:max-h-14" : "py-1.5 max-h-14",
			isSearchOpen && "hidden-t59")}>
			<div className="standard-section-width mx-auto horizontal-padding z-10 flex justify-between w-full">
				{!hideHeaderExtraLinks ?
					<div className="flex gap-4 font-semibold items-center justify-between w-full sm:justify-normal sm:w-fit extra-links">
						<Link to="/collections/open-box" className="hover:opacity-75 text-sm"
							onClick={() => isSearchOpen && toggleSearch()}>
							Open Box
						</Link>
						<Link to="/mod-pro" className="hover:opacity-75 flex text-sm"
							onClick={() => isSearchOpen && toggleSearch()}>
							Join Our B2B Program
						</Link>
					</div>
					: <p />
				}
				<div className="contact-info">
					<>
						<Swiper {...settings} className="special-links-variant-2">
							{contactInfo.map((item, index) => (
								<SwiperSlide className="font-bold" key={index}>
									<Link to={item.url} key={index} className="t-contact-nav-link flex justify-center"
										onClick={() => isSearchOpen && toggleSearch()}>
										{item.title}
									</Link>
								</SwiperSlide>
							))}
						</Swiper>
						<>
							<button className="left-arrow-an" aria-label="left arrow">
								<StandardArrow className="rotate-180 size-4 invert" />
							</button>
							<button className="right-arrow-an" aria-label="right-arrow">
								<StandardArrow className="size-4 invert" />
							</button>
						</>
					</>
					{contactInfo?.map((item, index) => (
						<Link to={item.url} key={index} className="t-contact-nav-link nav-link"
							onClick={() => isSearchOpen && toggleSearch()}>
							{item.title}
						</Link>
					))}
				</div>
			</div>
		</div>
	);
};

export default DesktopSpecialLinks;